/**
 * @file 面包屑组件
 * @author lisiqi06
 */

import {Breadcrumb} from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {noop} from 'lodash';
import styles from './index.less';

const Ellipsis = () => <span>...</span>;

const getClassNames = ({mode, className}) => classNames(
    styles.root,
    className,
    {[styles.verticalMode]: mode === 'vertical'}
);

const shouldShowEllipsis = ({mode, showEllipsis, routes = [], children = []}) => (
    mode === 'vertical' && showEllipsis && (routes.length >= 5 || children.length >= 5)
);

const getItemRenderWithEllipsis = render => (route, params, routes, paths) => {
    const index = routes.indexOf(route);

    if (index === 1) {
        return <Ellipsis />;
    }

    if (index > 1 && index < routes.length - 2) {
        return null;
    }

    return render(route, params, routes, paths);
};


const getChildrenWithEllipsis = children => {
    if (children.length < 5) {
        return children;
    }

    return [
        children[0],
        <Breadcrumb.Item key="_ellipsis"><Ellipsis /></Breadcrumb.Item>,
        ...children.slice(-2)
    ];
};

const CustomBreadcrumb = props => {
    const {children, routes, itemRender, params, separator, mode, showEllipsis} = props;

    const isShowEllipsis = shouldShowEllipsis({mode, showEllipsis, routes, children});

    return (
        <Breadcrumb
            className={getClassNames(props)}
            itemRender={isShowEllipsis && itemRender ? getItemRenderWithEllipsis(itemRender) : itemRender}
            routes={routes}
            params={params}
            separator={separator}
        >
            {isShowEllipsis && children ? getChildrenWithEllipsis(children) : children}
        </Breadcrumb>
    );
};

Object.assign(CustomBreadcrumb, Breadcrumb);

CustomBreadcrumb.propTypes = {
    itemRender: PropTypes.func,
    params: PropTypes.object,
    routes: PropTypes.array,
    separator: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    mode: PropTypes.oneOf(['default', 'vertical']),
    showEllipsis: PropTypes.bool
};

CustomBreadcrumb.defaultProps = {
    itemRender: noop,
    params: undefined,
    routes: undefined,
    separator: '/',
    mode: 'default',
    showEllipsis: false
};

export default CustomBreadcrumb;
